// Decodificador base64 → bytes, próprio (sem dependência nova) para o
// upload de fotos ao Supabase Storage (Etapa 11). O padrão documentado do
// Supabase para React Native é ler o arquivo local com
// `expo-file-system#readAsStringAsync(uri, { encoding: Base64 })` e
// decodificar o base64 resultante antes de passar para
// `storage.from(bucket).upload(path, bytes, ...)` — `fetch(uri).arrayBuffer()`
// sobre um `file://` não é confiável em React Native (suporte histórico
// incompleto de Blob/fetch para URIs locais), por isso não é usado aqui.
//
// Pacotes prontos para isso existem (ex. `base64-arraybuffer`, usado no
// exemplo oficial do Supabase), mas não estão no projeto e a lógica é
// pequena o bastante para não justificar uma dependência nova (mesma régua
// de YAGNI aplicada à decisão de não instalar uma lib de detecção de rede
// nesta etapa — ver retryWithBackoff.ts). Função pura, testável direto.
const BASE64_ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

/** Decodifica uma string base64 (com ou sem padding `=`) para bytes crus. */
export function decodeBase64ToBytes(base64: string): Uint8Array {
  const clean = base64.replace(/[^A-Za-z0-9+/]/g, '');
  const bytes: number[] = [];
  let buffer = 0;
  let bits = 0;

  for (const char of clean) {
    const value = BASE64_ALPHABET.indexOf(char);
    if (value === -1) continue;
    buffer = (buffer << 6) | value;
    bits += 6;
    if (bits >= 8) {
      bits -= 8;
      bytes.push((buffer >> bits) & 0xff);
    }
  }

  return Uint8Array.from(bytes);
}
